import { CompanyStructure } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorIsBusinessTypeOnePerson = (
  businessType?: string
): boolean =>
  !businessType ||
  businessType === CompanyStructure.LlcSingleMember ||
  businessType === CompanyStructure.SoleProprietorship ||
  businessType === CompanyStructure.None;
